import { React, useEffect, useState, } from 'react';
import { Link as RouterLink, useNavigate, useLocation } from 'react-router-dom';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import CloseIcon from '@mui/icons-material/Close';


// material
import {
    Card,
    IconButton,
    Stack,
    Button,
    TextField,
    Divider,
    FormControl,
    MenuItem,
    InputLabel, Select,
    Autocomplete,
    Tooltip,
    Modal,
    Box,
    Tabs,
    Tab,
    Typography
} from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { startOfMonth, endOfMonth, format } from 'date-fns';
import { useSnackbar } from 'notistack';
import Moment from 'moment';
import { Icon } from '@iconify/react';
import * as XLSX from 'xlsx';
import Iconify from '../../Iconify';
import URLS from '../../../services/urls.service';
import LoadingProgressBar from '../../../theme/overrides/LoadingProgressBar';
import Page from '../../Page';
import { handleError } from '../../Common/Utils';
import AppCache from '../../../services/AppCache';
import CustomDataGrid from '../../Common/CustomDataGrid';

// ----------------------------------------------------------------------


// ----------------------------------------------------------------------
const style = {
    position: 'absolute',
    top: '50%',
    justifyContent: 'center',
    left: '50%',
    transform: 'translate(-50%, -50%)',

    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 10,
    p: 4,
};
const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '70%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 1,
    maxHeight: '80vh',
    overflow: 'auto',
    borderRadius: '8px',
};

const stripHtml = (html) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    const text = tempDiv.textContent || tempDiv.innerText || "";
    return text
        .replace(/\u00A0/g, " ")   // replace non-breaking space
        .replace(/\s+/g, " ")      // collapse whitespace
        .trim();
};

const tmpCache = {
    effectiveFromValue: null,
    effectiveToValue: null,
    trackerMasterId: null,
    issueId: null,
    userId: null,
};
let shouldReload = false;
export default function ServiceRequestBDTrackerListingPage({ trackerMasterId, trackerName, allowAdd, allowEdit, allowDelete, trackerId }) {

    console.log("trackerMasterId>>>>>>>>>>>>>>>>", trackerMasterId, "trackerId", trackerId)
    const historyGridData = [
        {
            field: 'EditedDateTime',
            headerName: 'Edited Date Time',
            width: 150, // Explicit width
        },
        {
            field: 'EditedBy',
            headerName: 'Edited By',
            width: 130, // Explicit width
        },
        {
            field: 'ChangeDetails',
            headerName: 'Description',
            width: 300, // Explicit width
            renderCell: (params) => {
                const changeDetails = params.value;

                if (!changeDetails?.trim()) return <span>-</span>;

                // Replace {} with <strong> and () with <em>
                const formattedText = changeDetails
                    .replace(/{([^}]+)}/g, (_, p1) => `<strong>${p1}</strong>`)
                    .replace(/\(([^)]+)\)/g, (_, p1) => `<em>${p1}</em>`);

                return (
                    <span
                        style={{ fontFamily: 'Inter, sans-serif' }}
                        dangerouslySetInnerHTML={{ __html: formattedText }}
                    />
                );
            },
        }

    ];

    const linkedHitoryColumn = [
        {
            field: 'EditedDateTime',
            headerName: 'Edited Date Time',
            width: 150, // Explicit width
        },
        {
            field: 'EditedBy',
            headerName: 'Edited By',
            width: 130, // Explicit width
        },
        {
            field: 'ChangeDetails',
            headerName: 'Description',
            width: 300, // Explicit width
            renderCell: (params) => {
                const changeDetails = params.value;

                if (!changeDetails?.trim()) return <span>-</span>;

                // Replace {} with <strong> and () with <em>
                const formattedText = changeDetails
                    .replace(/{([^}]+)}/g, (_, p1) => `<strong>${p1}</strong>`)
                    .replace(/\(([^)]+)\)/g, (_, p1) => `<em>${p1}</em>`);

                return (
                    <span
                        style={{ fontFamily: 'Inter, sans-serif' }}
                        dangerouslySetInnerHTML={{ __html: formattedText }}
                    />
                );
            },
        }

    ];
    const [tabValue, setTabValue] = useState(0);

    const { enqueueSnackbar } = useSnackbar();
    const location = useLocation();
    const navigate = useNavigate();

    const [historyData, setHistoryData] = useState([]);
    const [pageSize, setPageSize] = useState(25);
    const [pageSize2, setPageSize2] = useState(25);


    const [effectiveFromValue, setEffectiveFromValue] = useState(tmpCache.effectiveFromValue ?? startOfMonth(new Date()));
    const [effectiveToValue, setEffectiveToValue] = useState(tmpCache.effectiveToValue ?? endOfMonth(new Date()));
    const [reports, setReports] = useState([]);
    const [columns, setColumns] = useState([])
    const [filteredReports, setFilteredReports] = useState([]); // Filtered data

    const [isLoading, setIsLoading] = useState();
    const [issueId, setIssueId] = useState('');
    const [editData, setEditData] = useState([])
    const [open, setOpen] = useState(false);

    const [historyOpen, setHistoryOpen] = useState(false);

    const [reopenModal, setReopenModal] = useState(false);
    const [selectedReopenRow, setSelectedReopnRow] = useState(null);

    const [selectedRow, setSelectedRow] = useState(null);
    const [deleteRowId, setDeleteRowId] = useState('');

    const [lagInterval, setLagInterval] = useState('');

    const [lageIntervalddl, setLagIntervalddl] = useState(tmpCache.lageIntervalddl ?? '');
    const [selectedLagIntervalddl, setSelectedLagIntervalddl] = useState(tmpCache.selectedLagIntervalddl ?? []);

    const [showDDL, setShowDDL] = useState(false);

    const CurrentLoggedInUser = AppCache.GetCurrentLoggedInUser();
    const userId = CurrentLoggedInUser.ExecutiveId;
    const isSaplUser = CurrentLoggedInUser?.IsSaplUser;

    const [loadTrackerData, setLoadTrackerData] = useState(tmpCache.loadTrackerData ?? []);
    const [linkedIncidentId, setLinkedIncidentId] = useState(null);
    const [linkedHistoryData, setLinkedHistoryData] = useState([]);

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);

    };
    const handleEffFrom = (newValue) => {
        setEffectiveFromValue(newValue)
    };
    const handleEffTo = (newValue) => {
        setEffectiveToValue(newValue)
    };
    const handleReopenModal = (cellValues) => {
        // Set loading state to true when opening
        setSelectedReopnRow(cellValues);
        setReopenModal(true);

    };
    const handleReopenCloseModal = () => {
        // Set loading state to true when opening
        setSelectedReopnRow(null);

        setReopenModal(false);

    };
    const handleConfirmReopen = () => {
        if (!selectedReopenRow) return;
        setIsLoading(true);
        shouldReload = true;
        const isReopen = selectedReopenRow?.row.Reopen
        console.log("selectedReopenRow", selectedReopenRow, selectedReopenRow.row, isReopen)
        URLS.editLoadData({ Id: selectedReopenRow.row.ID, TrackerMasterId: trackerId ?? trackerMasterId, })
            .then((response) => {
                const jsonDataString = JSON.stringify(response.data);

                const modifiedData = JSON.parse(jsonDataString);
                console.log("modifiedData", modifiedData)
                setEditData(modifiedData);
                navigate('/dashboard/servicerequesttrackerdetailspage', { state: { tracker: modifiedData, trackerMasterId, loadTrackerData, trackerName, isReopen } })

            })
            .catch(error => {
                // On error
                enqueueSnackbar("Record not found", { variant: 'success' });
                setIsLoading(false);

            });
    };

    const handleHistoryOpen = (cellValues) => {
        // Set loading state to true when opening
        setTabValue(0);
        setIsLoading(true);
        setHistoryOpen(true);

        console.log("cellValues", cellValues, cellValues.row)
        const payload = {
            TrackerMasterId: trackerMasterId,
            TrackerRequestId: cellValues.row.ID
        }

        URLS.editLoadData({ Id: cellValues.row.ID, TrackerMasterId: trackerId ?? trackerMasterId, })
            .then((response) => {
                const jsonDataString = JSON.stringify(response.data);

                const modifiedData = JSON.parse(jsonDataString);

                const parentId = modifiedData.DataTable?.[0]?.ParentIncidentId;
                const childId = modifiedData.DataTable?.[0]?.ChildIncidentId;

                // Show tab only when they are NOT equal
                // Pass parentId when valid, else null
                const linkedId = parentId !== childId ? parentId : null;
                setLinkedIncidentId(linkedId);
                console.log("modifiedData", modifiedData)

            })
            .catch(error => {
                // On error
                enqueueSnackbar("Record not found", { variant: 'success' });


            });

        URLS.serviceRequestTrackerHistory(payload)
            .then((response) => {
                console.log("res", response);
                setIsLoading(false); // Stop loading
                setHistoryData(response.data || []); // Set response data to historyData
            })
            .catch((error) => {
                console.error("Error loading tracker data:", error);
                setIsLoading(false); // Stop loading in case of error
                setHistoryData([]); // Clear historyData on error
            })

    };


    const handleHistoryClose = () => {
        // Close history view and reset states
        setTabValue(0);
        setHistoryOpen(false);
        setHistoryData([]); // Clear the previous history data when closing
        setIsLoading(false); // Reset loading state when closing
        setLinkedHistoryData([]);
    };
    useEffect(() => {
        if (tabValue === 1 && linkedIncidentId) {
            URLS.serviceRequestTrackerHistory({
                TrackerRequestId: linkedIncidentId,
                TrackerMasterId: trackerMasterId,
            })
                .then((res) => setLinkedHistoryData(res.data || []))
                .catch((error) => {
                    console.error("Error loading tracker data:", error);
                    setLinkedHistoryData([]); // Clear historyData on error
                })
        }
    }, [tabValue, linkedIncidentId]);


    const generateColumns = (data) => {
        if (!data || data.length === 0) return [];
        const firstRow = data[0];

        // Generate dynamic columns, excluding "Reopen"
        const columns = Object.keys(firstRow)
            .filter((key) => key !== "Reopen" && key !== "IsEdit" && key !== "IsReopen" && key !== "ColorCode") // hide Reopen column
            .map((key) => ({
                field: key,
                headerName: key
                    .replace(/([A-Z])/g, " $1")
                    .replace(/^./, (str) => str.toUpperCase()),
                width: 120,
                // Strip HTML for export + display
                valueGetter: (params) => {
                    const value = params.row[key];
                    return typeof value === "string"
                        ? stripHtml(value)
                        : value;
                },
                renderCell: (params) => {
                    const { value } = params;
                    const plainText =
                        typeof value === "string"
                            ? stripHtml(value)
                            : value;

                    return (
                        <Tooltip title={
                            <div
                                style={{
                                    maxHeight: "150px",   // height limit
                                    overflowY: "auto",    // vertical scrollbar
                                    whiteSpace: "pre-wrap",
                                    wordBreak: "break-word",
                                    paddingRight: "4px",
                                }}
                            >
                                {plainText}
                            </div>
                        }>
                            <div
                                style={{
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    width: "100%",
                                }}
                            >
                                {plainText}
                            </div>
                        </Tooltip>
                    );
                },
            }));


        const actionColumn = {
            field: 'actions',
            headerName: 'Actions',
            type: 'actions',
            width: 180,
            renderCell: (cellValues) => {
                const showReopen = cellValues.row.Reopen === 1; // Reopen flag from API
                const canEdit = cellValues.row.IsEdit === true;
                return (
                    <div
                        style={{
                            display: "flex",             // ✅ enable flexbox
                            justifyContent: "flex-end",  // ✅ align buttons to right
                            gap: "4px",                  // optional: spacing between buttons
                            width: "100%",               // take full cell width
                        }}
                    >
                        {showReopen && (
                            // Show only Reopen button
                            <Tooltip title="Reopen">
                                <IconButton
                                    onClick={() =>
                                        handleReopenModal({ ...cellValues, reopen: cellValues.row.Reopen })
                                    }
                                    color="default"
                                >
                                    <Iconify
                                        icon="humbleicons:restart"
                                        width="20px"
                                        height="20px"
                                        color="primary.main"
                                    />
                                </IconButton>
                            </Tooltip>
                        )}
                        {canEdit && (
                            <>
                                <Tooltip title="Edit">
                                    <IconButton
                                        onClick={(event) => handleClick(event, { ...cellValues, reopen: cellValues.row.Reopen, })}
                                        color="primary"
                                    >
                                        <Iconify
                                            icon="ic:outline-edit"
                                            width="20px"
                                            height="20px"
                                        />
                                    </IconButton>
                                </Tooltip>
                                {isSaplUser && (
                                    <Tooltip title="Delete">
                                        <IconButton
                                            onClick={() => handleDelete(cellValues)}
                                            color="secondary"
                                        >
                                            <Iconify
                                                icon="ic:baseline-delete"
                                                width="20px"
                                                height="20px"
                                                color="primary.main"
                                            />
                                        </IconButton>
                                    </Tooltip>
                                )}

                            </>
                        )}
                        {/* History is always shown */}
                        <Tooltip title="History">
                            <IconButton
                                onClick={() => handleHistoryOpen(cellValues)}
                                color="default"
                            >
                                <Iconify
                                    icon="mdi:clipboard-text-history-outline"
                                    width="20px"
                                    height="20px"
                                    color="primary.main"
                                />
                            </IconButton>
                        </Tooltip>
                    </div>
                );
            },
        };

        // Append the action column to the dynamic columns
        return [...columns, actionColumn];
    };

    const removeLastPipe = (val = "") => {
        if (typeof val !== "string") return val;

        // Replace double pipe (||) with comma
        return val
            .replace(/\s*\|\|\s*/g, ", ")
            .trim();
    };

    const processFilterData = (rows = [], trackerData = []) => {
        const col = [...trackerData]
            .reverse()
            .find(c => [8, 9].includes(c.UIControlKeyId));

        if (!col) return rows;

        return rows.map(row =>
            row[col.ColumnName]
                ? { ...row, [col.ColumnName]: removeLastPipe(row[col.ColumnName]) }
                : row
        );
    };

    const onFilterClick = () => {
        setIsLoading(true);
        const formDate = format(effectiveFromValue, 'dd-MMM-yyyy');
        const toDate = format(effectiveToValue, 'dd-MMM-yyyy');
        const lagPaylod = {
            "TrackerId": trackerId ?? trackerMasterId,
            "LagDaysInterval": lagInterval,
            "FromDate": formDate,
            "ToDate": toDate,
            "LoginId": userId
        };

        const payload = {
            FromDate: formDate,
            ToDate: toDate,
            IssueId: issueId ?? tmpCache.issueId ?? "",
            TrackerMasterId: trackerId ?? trackerMasterId,
            Id: userId
        }
        console.log("payload", payload)
        URLS.filterIssueTrackerData(payload)
            .then((response) => {
                const rawData = response.data?.DataTable || [];
                const data = processFilterData(rawData, loadTrackerData);

                setReports(data);
                setShowDDL(true);
                setColumns(generateColumns(data)); // Pass the data to generate columns
                setFilteredReports(data);
                setIsLoading(false);
                enqueueSnackbar("Records Fetched successfully", { variant: 'success' });
                console.log("data", data)

            })
            .catch(error => {
                // On error
                setReports([]);
                setShowDDL(false);
                setFilteredReports([]);
                enqueueSnackbar("Record not found", { variant: 'success' });
                setIsLoading(false);
            });
        if (lagInterval) {
            URLS.fetchServiceRequestLagDays(lagPaylod)
                .then((response) => {
                    console.log("res", response)
                    setSelectedLagIntervalddl(response.data)
                })
                .catch((error) => {
                    console.error("Error loading tracker data:");
                });
        }

    };

    const handleClick = (event, cellValues) => {
        console.log(cellValues.row.ID, "cellValues", cellValues, cellValues?.row.Reopen)
        setIsLoading(true);
        shouldReload = true;
        const isReopen = cellValues?.row.Reopen
        URLS.editLoadData({ Id: cellValues.row.ID, TrackerMasterId: trackerId ?? trackerMasterId, })
            .then((response) => {
                const jsonDataString = JSON.stringify(response.data);

                const modifiedData = JSON.parse(jsonDataString);
                console.log("modifiedData", modifiedData)
                setEditData(modifiedData);
                navigate('/dashboard/servicerequesttrackerdetailspage', { state: { tracker: modifiedData, trackerMasterId, loadTrackerData, trackerName, isReopen } })

            })
            .catch(error => {
                // On error
                enqueueSnackbar("Record not found", { variant: 'success' });
                setIsLoading(false);

            });
    }

    const handleDelete = (cellValues) => {
        console.log('Delete clicked', cellValues.row);
        setSelectedRow(cellValues.row); // Set the selected row data
        setDeleteRowId(cellValues.row.ID)
        setOpen(true); // Open the modal
    };


    const handleClose = () => {
        setOpen(false);
        setSelectedRow(null);
    };

    const handleConfirmDelete = (confirmed) => {
        console.log("confirmed", confirmed)
        if (confirmed !== null) {
            const payload = { ServiceId: selectedRow.ServiceRequestId, LogginUserId: userId, TrackerMasterId: trackerId ?? trackerMasterId, Id: deleteRowId };
            const formDate = format(effectiveFromValue, 'dd-MMM-yyyy');
            const toDate = format(effectiveToValue, 'dd-MMM-yyyy');
            const filterPayload = { FromDate: formDate, ToDate: toDate, IssueId: issueId, TrackerMasterId: trackerId ?? trackerMasterId, Id: userId }

            URLS.deleteIssueTrackerData(payload)
                .then((response) => {
                    console.log("response", response)
                    if (response.status === 200) {
                        enqueueSnackbar("Deleted data successfully", { variant: 'success' });
                        setOpen(false);


                        URLS.filterIssueTrackerData(filterPayload)
                            .then((response) => {
                                const rawData = response.data?.DataTable || [];
                                const data = processFilterData(rawData, loadTrackerData);

                                setReports(data);
                                setFilteredReports(data);
                                setIsLoading(false);
                                enqueueSnackbar("Records Fetched successfully", { variant: 'success' });
                            })
                            .catch(error => {
                                // On error
                                setReports([])
                                setFilteredReports([]);
                                enqueueSnackbar("Record not found", { variant: 'success' });
                                setIsLoading(false);

                            });

                        // Filter out the deleted row from the reports

                    }
                })
                .catch((error) => {
                    enqueueSnackbar("Failed to delete record", { variant: 'error' });
                    console.error(error);
                });
        }
    };

    const hanleLagInterval = (event) => {
        setLagInterval(event.target.value)
    }
    const handleLagDDL = (range) => {
        setLagIntervalddl(range);
        if (!range) {
            setFilteredReports(reports);
        } if (range.includes('+')) {
            const min = parseInt(range.replace('+', ''), 10);
            const filtered = reports.filter((report) => report.LagInterval > min);
            setFilteredReports(filtered);
        } else {
            const [min, max] = range.split('-').map(Number);

            const filtered = reports.filter(
                (report) => report.LagInterval >= min && report.LagInterval <= max
            );

            setFilteredReports(filtered);
        }
    };

    const handleReset = () => {
        setReports([]);
        setEffectiveFromValue(startOfMonth(new Date()));
        setEffectiveToValue(endOfMonth(new Date()));
        setFilteredReports([]);
        setShowDDL(false);
    }

    const onExportClick = (rowsToExport) => {
        // Exclude "Reopen" and "IsEdit" columns from the data
        const filteredReports = rowsToExport.map(({ Reopen, IsEdit, IsReopen, ColorCode, ...rest }) => rest);
        const payload = {
            TrackerName: trackerName || "",
            Data: filteredReports
        };
        URLS.exportExcel(payload)
            .then((response) => {
                if (response.status === 200 && response.data && response.data.filepath) {
                    const link = document.createElement('a');
                    link.href = response.data.filepath;
                    link.setAttribute('download', '');
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);

                    enqueueSnackbar("Excel data downloaded successfully", { variant: 'success' });
                }
            })
            .catch((error) => {
                enqueueSnackbar("File not found", { variant: 'error' });
                setIsLoading(false);
            });
    };

    useEffect(() => {
        // setUserId(CurrentLoggedInUser.ExecutiveId);
        setIsLoading(true);

        const payload = { Id: trackerId ?? trackerMasterId };

        URLS.loadIssueTrackerData(payload)
            .then((response) => {

                setLoadTrackerData(response.data);
                setIsLoading(false);
            })
            .catch((error) => {
                setIsLoading(false);

                console.error("Error loading tracker data:");
            });
        URLS.getTrackerLagInterval(payload)
            .then((response) => {
                console.log("res", response)
                setLagInterval(response.data.DefaultLagDays)
            })
            .catch((error) => {
                console.error("Error loading tracker data:");
            });

    }, []);

    useEffect(() => {
        tmpCache.effectiveFromValue = effectiveFromValue;
        tmpCache.effectiveToValue = effectiveToValue;
        tmpCache.trackerMasterId = trackerMasterId;
        tmpCache.issueId = issueId;
        tmpCache.userId = userId;
        tmpCache.loadTrackerData = loadTrackerData;
        tmpCache.lagInterval = lagInterval
        tmpCache.lageIntervalddl = lageIntervalddl
        tmpCache.selectedLagIntervalddl = selectedLagIntervalddl
    }, [effectiveFromValue, effectiveToValue, trackerMasterId, issueId, userId, loadTrackerData, lagInterval, lageIntervalddl, selectedLagIntervalddl]);


    useEffect(() => {
        // Only call API if coming back from detail
        if (shouldReload && tmpCache.effectiveFromValue && tmpCache.effectiveToValue) {
            onFilterClick();
            shouldReload = false; // reset after using
        }
    }, []);

    useEffect(() => {
        // Clear temp cache when trackerId changes
        tmpCache.effectiveFromValue = null;
        tmpCache.effectiveToValue = null;
        tmpCache.trackerMasterId = trackerId;
        tmpCache.issueId = null;
        tmpCache.userId = null;
        tmpCache.loadTrackerData = null;
        tmpCache.lagInterval = null;
        tmpCache.lageIntervalddl = null;
        tmpCache.selectedLagIntervalddl = null;

        // Reset state too
        // Reset filters only, do not clear loadTrackerData (it will re-fetch for the new tracker)

        // setEffectiveFromValue(startOfMonth(new Date()));
        // setEffectiveToValue(endOfMonth(new Date()));
        setIssueId("");
        setLagInterval("");
        setLagIntervalddl("");
        setSelectedLagIntervalddl([]);
        setReports([]);
        setFilteredReports([]);
        setShowDDL(false);
        setColumns([]);

        // trigger loadTrackerData fetch for the new trackerId
        const payload = { Id: trackerId ?? trackerMasterId };
        URLS.loadIssueTrackerData(payload)
            .then((response) => {
                setLoadTrackerData(response.data);
            })
            .catch((error) => {
                console.error("Error loading tracker data:", error);
                setLoadTrackerData([]);
            });

        URLS.getTrackerLagInterval(payload)
            .then((response) => {
                setLagInterval(response.data.DefaultLagDays);
            })
            .catch((error) => {
                console.error("Error loading tracker lag interval:", error);
            });


    }, [trackerId]);


    // useEffect(() => {
    //    setReports([]);
    //    setEffectiveFromValue(startOfMonth(new Date()));
    //    setEffectiveToValue(endOfMonth(new Date()));
    //    setFilteredReports([]);
    //    setShowDDL(false);
    // }, [location.key])
    console.log("loadTrackerData", filteredReports, loadTrackerData)

    return (
        <Page title="JJCore Incident Tracker  Listing">
            <Card>
                <Stack direction="column" m={1} spacing={2}>

                    <Stack direction="row" spacing={2}>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DesktopDatePicker
                                label="From Date"
                                inputFormat="dd/MMM/yyyy"
                                value={Moment(effectiveFromValue).format('DD-MMM-yyyy')}
                                onChange={handleEffFrom}
                                renderInput={(params) => <TextField fullWidth size="small" {...params} sx={{ flexGrow: 1 }} />}
                            />
                        </LocalizationProvider>

                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DesktopDatePicker
                                label="To Date"
                                inputFormat="dd/MMM/yyyy"
                                value={Moment(effectiveToValue).format('DD-MMM-yyyy')}
                                onChange={handleEffTo}
                                renderInput={(params) => <TextField fullWidth size="small" {...params} sx={{ flexGrow: 1 }} />}
                            />
                        </LocalizationProvider>
                        <TextField
                            fullWidth
                            label="Lag Interval"
                            size="small"
                            value={lagInterval}
                            onChange={hanleLagInterval}
                        />
                        {showDDL && (
                            <FormControl
                                size="small"
                                fullWidth
                            >
                                <InputLabel InputLabelProps={{ style: { color: 'green', fontSize: '14px' } }} >Lag Interval</InputLabel>
                                <Select
                                    label="Lag Interval"
                                    size="small"
                                    value={lageIntervalddl}
                                    onChange={(e) => handleLagDDL(e.target.value)}
                                    MenuProps={{
                                        PaperProps: {
                                            sx: {
                                                backgroundColor: '#fbe9e7', // Set the background color here
                                                maxHeight: '200px',
                                                width: '200px',// Set the max height here
                                            }
                                        }
                                    }}
                                >
                                    <MenuItem key={0} value={""} onClick={() => handleLagDDL()} >Select</MenuItem>

                                    {selectedLagIntervalddl.map((product) => (
                                        <MenuItem key={product.Id} value={product.Range}>
                                            {`${product.Range} (${product.Count})`}
                                        </MenuItem>
                                    ))}
                                </Select>

                            </FormControl>
                        )}


                        <Stack direction="row" spacing={1} sx={{ flexGrow: 1 }}>
                            <Tooltip title="Filter">
                                <Button variant="contained" size="small" onClick={onFilterClick}>
                                    <Icon icon="ic:outline-filter-alt" width="25px" height="25px" />
                                </Button>
                            </Tooltip>

                            {allowAdd === true && (
                                <Tooltip title="Add New">
                                    <Button
                                        component={RouterLink}
                                        to="/dashboard/servicerequesttrackerdetailspage"
                                        variant="contained"
                                        size="small"
                                        state={{
                                            tracker: {
                                                Id: '',
                                                ControlType: ''
                                            },
                                            trackerMasterId,
                                            loadTrackerData,
                                            trackerName
                                        }}
                                    >
                                        <Icon icon="ic:baseline-plus" width="25px" height="25px" />
                                    </Button>
                                </Tooltip>
                            )}

                            <Tooltip title="Reset">
                                <Button variant="contained" size="small" onClick={handleReset}>
                                    <Icon icon="ic:twotone-restart-alt" width="25px" height="25px" />
                                </Button>
                            </Tooltip>
                        </Stack>
                    </Stack>
                </Stack>

                <Divider />

                <Modal
                    open={reopenModal}
                    onClose={handleReopenCloseModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Typography id="modal-modal-title" variant="h6" textAlign="center">
                            Are you sure you want to Reopen this record?
                        </Typography>
                        <Stack justifyContent="center" spacing={2} mt={2} direction="row">
                            <Button onClick={handleConfirmReopen} variant="contained" >
                                Yes
                            </Button>
                            <Button onClick={handleReopenCloseModal} variant="outlined">
                                No
                            </Button>
                        </Stack>
                    </Box>
                </Modal>

                <Modal
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Typography id="modal-modal-title" variant="h6" component="h2" textAlign="center">
                            Are you sure you want to delete this record?
                        </Typography>
                        <Stack justifyContent="center" spacing={2} mt={2} direction="row">
                            <Button onClick={handleConfirmDelete} variant="contained">
                                Yes
                            </Button>
                            <Button onClick={handleClose} variant="outlined" >
                                No
                            </Button>
                        </Stack>
                    </Box>
                </Modal>
                <Modal open={historyOpen} onClose={handleHistoryClose}>
                    <Box sx={{ ...modalStyle, position: 'relative', p: 2 }}>
                        {/* Close button */}
                        <IconButton
                            onClick={handleHistoryClose}
                            sx={{ position: 'absolute', top: 10, right: 10, color: 'grey', zIndex: 10, }}
                        >
                            <CloseIcon />
                        </IconButton>

                        {/* Tabs */}
                        <Tabs
                            value={tabValue}
                            onChange={handleTabChange}
                            sx={{
                                mb: 2,
                                "& .MuiTabs-indicator": {
                                    backgroundColor: "#3C97FF",
                                    height: "3px",
                                    borderRadius: "3px",
                                },
                            }}
                        >
                            <Tab
                                label="History"
                                sx={{
                                    textTransform: "none",
                                    fontWeight: tabValue === 0 ? "600" : "500",
                                    color: tabValue === 0 ? "#121212" : "#7B7B7B",
                                    fontSize: "14px",
                                }}
                            />
                            {linkedIncidentId &&
                                <Tab
                                    label="Linked Incident History"
                                    sx={{
                                        textTransform: "none",
                                        fontWeight: tabValue === 1 ? "600" : "500",
                                        color: tabValue === 1 ? "#121212" : "#7B7B7B",
                                        fontSize: "14px",
                                    }}
                                />
                            }
                        </Tabs>

                        {/* Tab Content */}
                        {tabValue === 0 && (
                            <Box>
                                {/* <Typography variant="h5" mb={1}> */}
                                {/*    History */}
                                {/* </Typography> */}
                                {isLoading && <LoadingProgressBar sx={{ py: 6 }} />}
                                {!isLoading && historyData?.length > 0 ? (
                                    <div style={{ height: '60vh' }}>
                                        <DataGrid
                                            rows={historyData}
                                            columns={historyGridData}
                                            getRowId={(row) => historyData.indexOf(row)}
                                            getRowHeight={() => 'auto'}
                                            density="compact"
                                            disableSelectionOnClick
                                            disableColumnMenu
                                            rowsPerPageOptions={[25, 50, 100]}
                                            pageSize={pageSize2}
                                            onPageSizeChange={(newPageSize) => setPageSize2(newPageSize)}
                                            sx={{
                                                '& .MuiDataGrid-columnHeaderTitle': { wordWrap: 'break-word', lineHeight: 1.2 },
                                                '& .MuiDataGrid-root': { border: '1px solid rgba(224,224,224,1)' },
                                                '& .MuiDataGrid-cell': { borderBottom: '1px solid rgba(224,224,224,1)' },
                                            }}
                                        />
                                    </div>
                                ) : (
                                    <Typography>No History Found.</Typography>
                                )}
                            </Box>
                        )}

                        {tabValue === 1 && linkedIncidentId && (
                            <Box>
                                {/* <Typography variant="h5" mb={1}> */}
                                {/*    Linked Incident Tracker */}
                                {/* </Typography> */}
                                {isLoading && <LoadingProgressBar sx={{ py: 6 }} />}
                                {!isLoading && linkedHistoryData?.length > 0 ? (
                                    <div style={{ height: '60vh' }}>
                                        <DataGrid
                                            rows={linkedHistoryData}
                                            columns={linkedHitoryColumn}
                                            getRowId={(row) => linkedHistoryData.indexOf(row)}
                                            getRowHeight={() => 'auto'}
                                            density="compact"
                                            disableSelectionOnClick
                                            disableColumnMenu
                                            rowsPerPageOptions={[25, 50, 100]}
                                            pageSize={pageSize2}
                                            onPageSizeChange={(newPageSize) => setPageSize2(newPageSize)}
                                            sx={{
                                                '& .MuiDataGrid-columnHeaderTitle': { wordWrap: 'break-word', lineHeight: 1.2 },
                                                '& .MuiDataGrid-root': { border: '1px solid rgba(224,224,224,1)' },
                                                '& .MuiDataGrid-cell': { borderBottom: '1px solid rgba(224,224,224,1)' },
                                            }}
                                        />
                                    </div>
                                ) : (
                                    <Typography>No Linked Incidents Found.</Typography>
                                )}
                            </Box>
                        )}
                    </Box>
                </Modal>

                <div style={{ height: '70vh', width: '100%' }}>
                    <CustomDataGrid
                        rows={filteredReports}
                        columns={columns}
                        pageSizeOptions={[25, 50, 100]}
                        defaultPageSize={25}
                        onExportClick={onExportClick}

                    />

                    {/* <DataGrid */}
                    {/*    rows={filteredReports} */}
                    {/*    columns={columns} */}
                    {/*    density={'compact'} */}
                    {/*    getRowId={(row) => reports.indexOf(row)} */}
                    {/*    components={{ */}
                    {/*        Toolbar: GridToolbar, */}
                    {/*    }} */}
                    {/*    rowsPerPageOptions={[25, 50, 100]} */}
                    {/* pageSize={pageSize} */}
                    {/*  onPageSizeChange={(newPageSize) => setPageSize(newPageSize)} */}
                    {/*    sx={{ */}
                    {/*        '& .MuiDataGrid-columnHeaderTitle': { */}
                    {/*            whiteSpace: 'normal', */}
                    {/*            overflow: 'visible', */}
                    {/*            lineHeight: '1.2', */}
                    {/*            wordWrap: 'break-word', */}
                    {/*        }, */}
                    {/*    }} */}

                    {/* /> */}
                </div>

            </Card>

            {isLoading && (<LoadingProgressBar sx={{ py: 6 }} />)}
        </Page>
    );


}